import { Controller } from '@hotwired/stimulus';
import { mountVueApp } from 'shared/vue/mountVueApp';
import { getPreviewUrl } from 'manage/utils/getPreviewUrl';

export default class extends Controller {
  static targets = ['template', 'psc', 'isc', 'desc'];

  connect() {
    const el = this.templateTarget;
    const pscPicture = this.pscTarget.dataset.picture;
    const iscPicture = this.iscTarget.dataset.picture;
    const descReferralCouponsDescriptionImage =
      this.descTarget.dataset.referralCouponsDescriptionImage;
    const descBanner = this.descTarget.dataset.banner;
    const descPicture = this.descTarget.dataset.picture;

    this.vueApp = mountVueApp(el, {
      data: {
        pscPicture,
        iscPicture,
        descReferralCouponsDescriptionImage,
        descBanner,
        descPicture,
      },
      methods: {
        onChangePsc(e) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.pscPicture = url;
          });
        },
        onChangeIsc(e) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.iscPicture = url;
          });
        },
        onChangeDescReferralCouponsDescriptionImage(e) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.descReferralCouponsDescriptionImage = url;
          });
        },
        onChangeDescBanner(e) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.descBanner = url;
          });
        },
        onChangeDescPicture(e) {
          const file = e.target.files[0];
          getPreviewUrl(file, (url) => {
            this.descPicture = url;
          });
        },
      },
    });
  }

  disconnect() {
    this.vueApp?.unmount();
  }
}
